module.exports = __webpack_public_path__ + "img/blazer-20.bbb39d3f.jpg";